import axios from "axios";
import { getVersion } from "./utils";

export const registryRequest = (
  getConfig,
  options,
  _url,
  payload,
  callback
) => {
  const version = getVersion(_url);
  const fallbackRegistryKey = getConfig(
    "one.axios.proxy.registry.key",
    "registryApi"
  );

  const url = version
    ? _url.replace(`@${version}--`, "--") + "?version=" + version
    : _url;

  const handleResponse = (res, callback) => {
    callback(null, {
      status: res.status,
      data: JSON.stringify(res.data)
    });
  };

  axios
    .get(url)
    .then((res) => {
      handleResponse(res, callback);
    })
    .catch((err) => {
      console.error(`OneFront/i18n: failed to load language file.\n${url}`);

      const fallbackUrl = url.replace("read", fallbackRegistryKey);
      console.warn(
        `[DEPRECATED] OneFront/i18n: attempting to load language file from fallback URL.\n${fallbackUrl}.\nPlease update your Proxy Service to the last version in order to use the new '/read' API route.`
      );

      axios
        .get(fallbackUrl)
        .then((res) => {
          handleResponse(res, callback);
        })
        .catch((err) => {
          console.error(
            `OneFront/i18n: failed to load language file.\n${fallbackUrl}`
          );
          callback(err);
        });
    });
};
